import { useMemo } from 'react';
import { TmdxAvatar } from '@ds';
import { getChangeLogDateTimeString } from '@lp/features/RoutePlanner/components/LogisticsChangeLog/utils';
import { LogisticsChangeLogUser } from '@/api/apis/route';
import { getFullName } from '@/utils/helpers';
import { UserType } from '@/api/apis/user';

type CreatedByUserProps = {
  user: LogisticsChangeLogUser;
  timestamp: string;
};

export const CreatedByUser = ({ user, timestamp }: CreatedByUserProps) => {
  const isSystemUser = user.userType === UserType.System;
  const userName = isSystemUser ? 'System User' : getFullName(user.firstName, user.lastName);
  const createdAtString = useMemo(() => {
    return getChangeLogDateTimeString(timestamp);
  }, [timestamp]);

  return (
    <div className="flex gap-1.5 items-center">
      <TmdxAvatar size="sm" radius="full" name={userName} src={user.photoPath} />
      <p className="text-s-m text-base-5">{userName}</p>
      <div className="h-1 w-1 bg-base-10 rounded-full" />
      <p className="text-s-r text-base-20">{createdAtString}</p>
    </div>
  );
};
